// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTreeContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTreeContainer component
 */
!(function() {


  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var connectionConstants = require('logic/data/Izenda.ConnectionConstants');
  var DataSourceTree = require('./Izenda.DataSourceTree');
  var classnames = require('classnames');
  const { isEmpty } = require('lodash/fp');
  /**
   * Selection data source tree that shows available and selected query source
   * in two data source tree UI.
   */
  var DataSourceTreeContainer = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    render: function() {
      var props = this.props;
      var store = this.props.store;
      var item = this.props.item;
      var localization = props.localization;

      if (isEmpty(item.dbSource)) {
        return null;
      }
      var className = classnames('row', 'datasource-container', { 'disabled-elm': props.disabled });
      return (
        <div className={className}>
          <label className="col-md-12">{connectionConstants.GUIDECONTENT}</label>
          <div className="col-md-6">
            <DataSourceTree
              store={store}
              tree={item.availableQuerySourceTree}
              showSelected={false}
              title={localization.getText('CONNECTION_AVAILABLE_DATA_SOURCE')}
            />
          </div>

          <div className="col-md-6">
            <DataSourceTree
              store={store}
              tree={item.selectedQuerySourceTree}
              showSelected={true}
              title={localization.getText('CONNECTION_VISIBLE_DATA_SOURCE')}
            />
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(DataSourceTreeContainer);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionConfig/DataSourceTree/Izenda.DataSourceTreeContainer.jsx